export enum THEMATIC {
  BANK = 'bank',
  LETTER_PACKAGE = 'letter-package',
  DT = 'dt',
  EXCELLENCE = 'excellence',
  INNOVATION = 'innovation',
  INTERNATIONAL = 'international',
  LOGISTIC = 'logistic',
  MEDIA = 'medias',
  PARTNERSHIP = 'partnership',
  HUMAN_RESOURCES = 'human-resource',
  HOME_SERVICE = 'home-service',
  TELECOM = 'telecom',
  DIGITAL = 'digital',
  ECOLOGY = 'ecology',
}
